module.exports = __webpack_public_path__ + "assets/img/kv-7e2ac742.jpg";